/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

const ResizeContext = React.createContext<number>(null);
const ResizeContextTrigger = React.createContext<(width: number) => void>(null);

export const ResizeProvider: React.FC<{ children?: React.ReactNode }> = React.memo(({ children }) => {
    const [val, triggerResize] = React.useState(0);

    return (
        <ResizeContext.Provider value={val}>
            <ResizeContextTrigger.Provider
                value={React.useCallback((_: number) => {
                    triggerResize(Math.random());
                }, [])}>
                {children}
            </ResizeContextTrigger.Provider>
        </ResizeContext.Provider>
    );
});

export const useResizeVal = () => React.useContext(ResizeContext);
export const useResizeTrigger = () => React.useContext(ResizeContextTrigger);
